import './js/shopping-list';
import './js/header';
import './js/support-ukraine';
import './js/pagination';
import './js/team-modal';
